/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react"
import { useRouteMatch } from "react-router"
import Grid from "../../../components/Grid/Grid"
import SelectItem from "../../../components/Grid/SelectItem"
import Loader from "../../../components/Loader/Loader"
import Pagination from "../../../components/Pagination/Pagination"
import { iArtifact, iArtifactQuery } from "../../../definitions/Artifacts"
import { iUrlParams } from "../../../definitions/interfaces"
import { useData } from "../../../hooks/useData"
import ArtifactsFilters from "../../Artifacts/Filters"
import ArtifactItem from "../../Artifacts/Item"

interface iProps {
  onChange?: (...event: any[]) => void
  value?: any
}

const ManageArtifacts: FunctionComponent<iProps> = ({ onChange }) => {
  const match = useRouteMatch<iUrlParams>()

  const { data } = useData<iArtifactQuery, iArtifact>({
    link: "/v2/exhibitions/" + match.params.url + "/artifacts",
    defaultQuery: {},
    shouldPingForData: false,
  })

  const [selected, setSelected] = useState<iArtifact[]>(data)
  const _selected = useRef<iArtifact[]>(data)

  useEffect(() => {
    setSelected(data)
    _selected.current = data
  }, [data])

  const { data: artifacts, query, setQuery, total, loading } = useData<
    iArtifactQuery,
    iArtifact
  >({
    link: "/v1/artifacts",
    defaultQuery: {},
    shouldPingForData: false,
  })

  const handleClick = useCallback(
    (artifact: iArtifact) => {
      if (_selected.current.find((a) => a._id === artifact._id)) {
        _selected.current = _selected.current.filter(
          (a) => a._id !== artifact._id,
        )
      } else {
        _selected.current = [..._selected.current, artifact]
      }

      setSelected(_selected.current)
      onChange && onChange(_selected.current.map((ap) => ap._id))
    },
    [setSelected],
  )

  const handleRemove = useCallback(
    (artifact: iArtifact) => {
      const tmp = _selected.current.filter((a) => a._id !== artifact._id)
      _selected.current = tmp
      setSelected(tmp)
      onChange && onChange(tmp.map((artifact) => artifact._id))
    },
    [setSelected],
  )

  return (
    <>
      <div className="content-header">
        <ArtifactsFilters query={query} setQuery={setQuery} />
      </div>
      <div className="flex-grids">
        <div className="col-6 grid-wrap">
          <label>Select artifact</label>
          {loading ? (
            <Loader />
          ) : (
            <Grid>
              {artifacts.map((artifact) => (
                <SelectItem<iArtifact>
                  key={artifact._id}
                  item={artifact}
                  isSelected={
                    !!selected.find(({ _id }) => _id === artifact._id)
                  }
                  onClick={handleClick}
                >
                  <ArtifactItem {...artifact} />
                </SelectItem>
              ))}
            </Grid>
          )}
        </div>
        <div className="grid-separator"></div>
        <div className="col-6 grid-wrap selected-wrap">
          <label>Selected artifacts</label>
          <Grid>
            {selected.map((artifact) => (
              <SelectItem<iArtifact>
                key={artifact._id}
                item={artifact}
                isSelected={false}
                onClick={handleRemove}
              >
                <ArtifactItem {...artifact} />
              </SelectItem>
            ))}
          </Grid>
        </div>
      </div>
      <Pagination total={total} setQuery={setQuery} limit={50} />
    </>
  )
}

export default ManageArtifacts
